import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil, concatAll, flatMap, find } from 'rxjs/operators';

import { RouteParamsService } from 'app/shared/service/route-params.service';

import { EditCompanyDashboardModalComponent } from '../edit-dashboard-modal/edit-company-dashboard-modal.component';
import { EditTeamDashboardModalComponent } from '../edit-dashboard-modal/edit-team-dashboard-modal.component';

@Component({
  selector: 'cc-add-edit-dashboard',
  template: '',
})
export class AddEditDashboardComponent implements OnInit, OnDestroy {
  unSubscribe = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly modal: NgbModal,
    private readonly routeParamsService: RouteParamsService,
  ) {}

  ngOnInit() {
    const teamId = this.route.snapshot.paramMap.get('teamId');
    const companyId = this.route.snapshot.paramMap.get('companyId');
    const dashboardId = this.route.snapshot.paramMap.get('dashboardId');

    let modalRef;
    if (companyId) {
      modalRef = this.modal.open(EditCompanyDashboardModalComponent);
    }

    if (teamId) {
      modalRef = this.modal.open(EditTeamDashboardModalComponent);
    }

    modalRef.componentInstance.teamId = teamId;
    modalRef.componentInstance.companyId = companyId;
    modalRef.componentInstance.dashboardId = dashboardId;
    modalRef.componentInstance.dashboard = this.routeParamsService.get('dashboards').pipe(
      takeUntil(this.unSubscribe),
      concatAll(),
      flatMap((dashboards) => dashboards as any),
      find((dashboard) => (dashboard as any)._id === dashboardId),
    );

    void modalRef.result.then(
      () => this.goBack(true),
      () => this.goBack(),
    );
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  private goBack(reload = false) {
    void this.router.navigate(['..'], { relativeTo: this.route, state: { reload } });
  }
}
